import { Component, Input } from '@angular/core';
import { environment } from '@environment/environment';
import { DerichebourgColorEnum } from '@shared/enums/color-derichebourg-enum';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzQRCodeModule } from 'ng-zorro-antd/qr-code';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-qr-code-app',
  imports: [
    NzQRCodeModule,
    NzButtonModule,
    NzIconModule,
    NzTooltipModule,
    NzModalModule,
    TranslateModule
  ],
  templateUrl: './qr-code-app.component.html',
  styleUrl: './qr-code-app.component.scss'
})
export class QrCodeAppComponent {
  /**
 * Url app string
 *
 * @public
 * @type {string}
 */
  public url: string = environment.msalConfig.auth.redirectUri;
  /**
   * Modal visibility
   *
   * @public
   * @type {boolean}
   */
  public isVisible: boolean = false;
  /**
   * Sidebar collapsed state
   *
   * @public
   * @type {boolean}
   */
  @Input() public sidebarCollapsed: boolean = false;
  /**
   * Color tooltip
   *
   * @public
   * @type {string}
   */
  public derichebourgColorBlue: string = DerichebourgColorEnum.BLUE;

  public openQrCodeModal() {
    this.isVisible = true;
  }

  public handleCancel() {
    this.isVisible = false;

  }

  public handleOk() {
    this.isVisible = false;
  }

}
